'use strict';

var $ = require('jquery');
var angular = require('angular');
var PopoverDirective = function PopoverDirective($timeout, popoverService, $document, $compile) {
  /*
   {
   offset: {top: number, left: number},
   height: number, - height of target
   width: number, - width of target
   };
   */
  return {
    restrict: 'E',
    template: require('../templates/popover.html'),
    transclude: true,
    scope: {
      triggerEventName: '@',
      placement: '@',
      position: '@',
      fixed: '@',
      showDelay: '@',
      hideDelay: '@',
      closeOnOutPopoverClick: '=?',
      compileDynamicContent: '@'
    },
    link: function link(scope, elem, attr, controller, transcludeFn) {
      function setDefaults() {
        scope.position = scope.position || 'right';
        scope.currentShowDelay = parseInt(scope.showDelay) || 0;
        scope.currentHideDelay = parseInt(scope.hideDelay) || 0;
        scope.isVisible = false;
        scope.closeOnOutPopoverClick = scope.closeOnOutPopoverClick || false;
        scope.compileDynamicContent = scope.compileDynamicContent || false;
      }
      setDefaults();
      function hideOnWindowClick(event) {
        if (!event.isTrigger && $(event.target).closest(elem).length === 0) {
          scope.hidePopover();
        }
      }
      function updateContent(data) {
        popoverContent.html(data);
        if (scope.compileDynamicContent) {
          $compile(popoverContent.contents())(scope);
        }
      }
      function updatePopoverPosition(popover, currentPosition, newPosition) {
        popover.removeClass('top bottom left right');
        popover.addClass(newPosition);
      }
      var popover = elem.find('.popover');
      var popoverContent = elem.find('.popover-content');
      var transcludeElement = transcludeFn(scope, angular.noop);
      popoverContent.append(transcludeElement);
      var showPromise = null;
      var hidePromise = null;
      function showPopover(data) {
        scope.data = data.entityData;
        scope.gridId = data.gridId;
        scope.placement = popoverService.getPlacementData(scope, data);
        if (data.htmlContent) {
          updateContent(data.htmlContent);
        }
        //show
        popover.addClass('transparent');
        popover.show();
        scope.isVisible = true;
        var popoverHeight = popover.outerHeight();
        var popoverWidth = popover.outerWidth();
        var updatedPlacementData = popoverService.getUpdatedPlacementData(data.targetPosition, popoverHeight, popoverWidth, scope.placement);
        updatePopoverPosition(popover, scope.position, updatedPlacementData.position);
        var popoverPosition = popoverService.calculatePosition(data.targetPosition, updatedPlacementData.placement, popoverWidth, popoverHeight);
        popover.css(popoverPosition);
        popover.removeClass('transparent');
        if (scope.closeOnOutPopoverClick) {
          $document.on('click', hideOnWindowClick);
        }
      }
      scope.hidePopover = function () {
        popover.hide();
        scope.isVisible = false;
        if (scope.closeOnOutPopoverClick) {
          $document.off('click', hideOnWindowClick);
        }
        hidePromise = null;
      };
      function updateShowHideDelays(data) {
        scope.currentShowDelay = data.showDelay ? data.showDelay : scope.showDelay;
        scope.currentHideDelay = data.hideDelay ? data.hideDelay : scope.hideDelay;
      }
      scope.$on(scope.triggerEventName + ':show', function (event, data) {
        updateShowHideDelays(data);
        $timeout.cancel(showPromise);
        $timeout.cancel(hidePromise);
        hidePromise = null;
        showPromise = $timeout(showPopover.bind(null, data), scope.currentShowDelay);
      });
      function hideTooltip() {
        if (hidePromise === null) {
          $timeout.cancel(showPromise);
          hidePromise = $timeout(scope.hidePopover, scope.currentHideDelay);
        }
      }
      scope.$on(scope.triggerEventName + ':hide', hideTooltip);
      scope.getCss = function () {
        return scope.position + '' + (scope.fixed ? ' fixed-pos' : '');
      };
      elem.on('$destroy', function () {
        $document.off('click', hideOnWindowClick);
      });
    }
  };
};
PopoverDirective.$inject = ['$timeout', 'PopoverService', '$document', '$compile'];
module.exports = PopoverDirective;